/*
 * atc-celebrate.js
 *  - Add-to-cart stays on the SAME page: intercepts homepage/card add forms,
 *    adds via /cart/add.js and shows Dawn's native top-right cart notification
 *    (product pages already do this). Cart count updates; no page reload.
 *  - Celebration: if a mascot image (window.ZIPPY_MASCOT) is set, "Zippy" swings
 *    in on a leafy rope and throws graffiti; otherwise a quick confetti burst.
 *  Dependency-free. Honors prefers-reduced-motion.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MASCOT = (window.ZIPPY_MASCOT || '').trim();
  var COLORS = ['#ff3b7f', '#ff5fa8', '#ff9fd0', '#e2187f', '#ff6b6b', '#ffb3c7'];
  function heartPath(c, s) {
    var t = s;
    c.beginPath();
    c.moveTo(0, t * 0.35);
    c.bezierCurveTo(0, t * 0.05, -t * 0.5, -t * 0.25, -t * 0.5, t * 0.12);
    c.bezierCurveTo(-t * 0.5, t * 0.45, -t * 0.1, t * 0.72, 0, t * 0.95);
    c.bezierCurveTo(t * 0.1, t * 0.72, t * 0.5, t * 0.45, t * 0.5, t * 0.12);
    c.bezierCurveTo(t * 0.5, -t * 0.25, 0, t * 0.05, 0, t * 0.35);
    c.closePath();
    c.fill();
  }

  /* ---------------- confetti / graffiti canvas (fast) ---------------- */
  var canvas, ctx, parts = [], raf = null;
  function ensure() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;';
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    resize();
    window.addEventListener('resize', resize);
  }
  function resize() {
    if (!canvas) return;
    var dpr = window.devicePixelRatio || 1;
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function burst(x, y, n) {
    ensure();
    n = n || 60;
    for (var i = 0; i < n; i++) {
      var angle = (Math.PI * 2 * i) / n + (i % 7) * 0.13;
      var speed = 7 + (i % 12);
      parts.push({
        x: x, y: y,
        vx: Math.cos(angle) * speed * (0.5 + (i % 5) / 5),
        vy: Math.sin(angle) * speed * (0.5 + (i % 3) / 3) - 5,
        g: 0.42 + (i % 4) * 0.05,
        size: 6 + (i % 6),
        rot: (i * 33) % 360,
        vr: (i % 2 ? 1 : -1) * (7 + (i % 10)),
        color: COLORS[i % COLORS.length],
        life: 22 + (i % 16),
        shape: i % 3
      });
    }
    if (!raf) raf = requestAnimationFrame(tick);
  }
  function tick() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.vy += p.g; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.life--;
      var a = Math.max(0, Math.min(1, p.life / 18));
      ctx.save();
      ctx.globalAlpha = a;
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rot * Math.PI) / 180);
      ctx.fillStyle = p.color;
      heartPath(ctx, p.size * 1.7);
      ctx.restore();
      if (p.life <= 0 || p.y - p.size > window.innerHeight) parts.splice(i, 1);
    }
    if (parts.length) { raf = requestAnimationFrame(tick); }
    else { cancelAnimationFrame(raf); raf = null; ctx.clearRect(0, 0, canvas.width, canvas.height); }
  }

  /* ---------------- Zippy mascot swing ---------------- */
  var swinging = false;
  function swing() {
    if (!MASCOT || swinging || !('animate' in HTMLElement.prototype)) return false;
    swinging = true;
    ensure();
    // The mascot art already includes its own branch + leaves, so we just hang the
    // image from the top of the viewport and swing it like a pendulum.
    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:fixed;top:-14px;left:50%;z-index:2147483001;pointer-events:none;transform-origin:top center;will-change:transform;';
    var img = document.createElement('img');
    img.src = MASCOT; img.alt = '';
    img.style.cssText = 'display:block;width:150px;height:auto;transform:translateX(-50%);filter:drop-shadow(0 8px 14px rgba(0,0,0,.32));';
    wrap.appendChild(img);
    document.body.appendChild(wrap);

    var anim = wrap.animate([
      { transform: 'translateX(-50%) rotate(-30deg)' },
      { transform: 'translateX(-14%) rotate(22deg)' },
      { transform: 'translateX(-60%) rotate(-15deg)' },
      { transform: 'translateX(-42%) rotate(8deg)' },
      { transform: 'translateX(-50%) rotate(0deg)' }
    ], { duration: 1500, easing: 'cubic-bezier(.4,0,.3,1)' });

    var throws = 0;
    var iv = setInterval(function () {
      var r = img.getBoundingClientRect();
      burst(r.left + r.width / 2, r.top + r.height * 0.72, 32);
      if (++throws >= 6) clearInterval(iv);
    }, 170);

    anim.onfinish = function () {
      clearInterval(iv);
      var up = wrap.animate(
        [{ transform: 'translateX(-50%) translateY(0)' }, { transform: 'translateX(-50%) translateY(-60vh)' }],
        { duration: 480, easing: 'ease-in', fill: 'forwards' }
      );
      up.onfinish = function () { wrap.remove(); swinging = false; };
    };
    return true;
  }

  function celebrate(x, y) {
    if (reduce) return;
    if (!swing()) burst(x, y, 70);
  }
  window.zippyCelebrate = celebrate;

  /* ---------------- fallback toast (only when no cart element) ---------------- */
  function toast(msg, ok) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;top:16px;right:16px;z-index:2147483002;background:' + (ok === false ? '#c0392b' : '#111') + ';color:#fff;padding:12px 16px;border-radius:10px;font:600 14px/1.2 sans-serif;box-shadow:0 6px 24px rgba(0,0,0,.25);transform:translateX(120%);transition:transform .3s ease;';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.transform = 'translateX(0)'; });
    setTimeout(function () { t.style.transform = 'translateX(120%)'; setTimeout(function () { t.remove(); }, 350); }, 2400);
  }

  /* ---------------- add-to-cart interception ---------------- */
  var lastX = window.innerWidth - 60, lastY = 80;
  document.addEventListener('click', function (e) { if (e.clientX) { lastX = e.clientX; lastY = e.clientY; } }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form && form.matches && form.matches('form[action*="/cart/add"]'))) return;
    // Product page / quick-add already AJAX-add via Dawn's <product-form>; just celebrate.
    if (form.closest('product-form')) { celebrate(lastX, lastY); return; }

    e.preventDefault();
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      try {
        // Dawn keys sections by section.id (NOT .section) for both the request and renderContents.
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      } catch (_) {}
    }
    var btn = form.querySelector('[name="add"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        var resp = res.data;
        if (!res.ok || resp.status) { toast(resp.description || resp.message || 'Could not add to cart', false); return; }
        // Added OK. Never let a rendering hiccup look like an add failure — always celebrate.
        try {
          if (cart && cart.renderContents) {
            if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
            cart.renderContents(resp);
          } else {
            updateCartCount();
            toast(((resp.quantity || 1)) + ' added to cart', true);
          }
        } catch (err) {
          updateCartCount();
          toast(((resp.quantity || 1)) + ' added to cart', true);
        }
        celebrate(lastX, lastY);
      })
      .catch(function () { toast('Could not add to cart', false); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }, true);

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child').forEach(function (s) { s.textContent = c.item_count; });
      }).catch(function () {});
  }
})();
